import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React, { FC, useEffect, useState } from 'react'
import InputComponent from 'app_components/commons/Input/InputComponent';
import { ITerm } from 'app_types/admin/term/term.types';

interface IModalFormProps {
  show: boolean
  handleClose: () => void
  title: string
  onCreate: (name: string, id?: string) => void
  termToEdit?: ITerm
}

const LIMIT_CHARACTERS = 50

const ModalForm:FC<IModalFormProps> = ({show, handleClose, title, onCreate, termToEdit}) => {

  const [name, setName] = useState<string>('')

  const handleClickSave = () => {
    if (name?.trim()?.length) {
      onCreate && onCreate(name, termToEdit?._id)
      handleClose && handleClose()
    }
  }

  useEffect(() => {
    if (termToEdit?._id && show) {
      setName(termToEdit?.name)
    } else {
      setName('')
    }
  }, [show, termToEdit])

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <InputComponent
            limit={LIMIT_CHARACTERS}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder='Nombre'
            label='Nombre'
            invalid={name?.length > LIMIT_CHARACTERS}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
          <Button variant="primary" disabled={!name?.length || name?.length > LIMIT_CHARACTERS} onClick={handleClickSave}>Guardar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalForm;
